import { useTranslation } from 'react-i18next';
import { Navigation } from '@cbridge-utils/navigation';
import { RouteSegments } from '../routingClientAdmin.interface';
import { useClientPageVisibility } from './useClientPageVisibility';

export const useConfigProfilesNavigationItems = () => {
  const { t } = useTranslation();
  // Only pricing profiles matter without the basicBridge feature; the rest configure trading
  const { isTradingVisible } = useClientPageVisibility();

  const items: Navigation = [
    {
      kind: 'header',
      title: t('text:navigation.config.profiles.title'),
    },
    ...(isTradingVisible ? [{
      kind: 'page' as const,
      segment: RouteSegments.Profiles.Routing,
      pattern: `${RouteSegments.Profiles.Routing}{/*path}`,
      title: t('text:navigation.config.profiles.routing'),
    }] : []),
    {
      kind: 'page',
      segment: RouteSegments.Profiles.Pricing,
      pattern: `${RouteSegments.Profiles.Pricing}{/*path}`,
      title: t('text:navigation.config.profiles.pricing'),
    },
    ...(isTradingVisible ? [
      {
        kind: 'page' as const,
        segment: RouteSegments.Profiles.Schedule,
        pattern: `${RouteSegments.Profiles.Schedule}{/*path}`,
        title: t('text:navigation.config.profiles.schedule'),
      },
      {
        kind: 'page' as const,
        segment: RouteSegments.Profiles.OrderLifetime,
        pattern: `${RouteSegments.Profiles.OrderLifetime}{/*path}`,
        title: t('text:navigation.config.profiles.orderLifetime'),
      },
      {
        kind: 'page' as const,
        segment: RouteSegments.Profiles.Adjustment,
        pattern: `${RouteSegments.Profiles.Adjustment}{/*path}`,
        title: t('text:navigation.config.profiles.adjustment'),
      },
      {
        kind: 'page' as const,
        segment: RouteSegments.Profiles.PriceFiltering,
        pattern: `${RouteSegments.Profiles.PriceFiltering}{/*path}`,
        title: t('text:navigation.config.profiles.priceFiltering'),
      },
      {
        kind: 'page' as const,
        segment: RouteSegments.Profiles.Spread,
        pattern: `${RouteSegments.Profiles.Spread}{/*path}`,
        title: t('text:navigation.config.profiles.spread'),
      },
    ] : []),
  ];

  return items;
};
